import script from "./modalSignup.vue?vue&type=script&lang=ts&setup=true"
export * from "./modalSignup.vue?vue&type=script&lang=ts&setup=true"

import "./modalSignup.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__